import getImage from "./getImage";
import makeRequest from "./makeRequest";

const http = {
    getImage,
    makeRequest
}

export default http;
